import React, { useState } from 'react'
import { useGwGoodsTypeSubAddMutation } from '../../store/ReactWebSiteApi';
import { Button, Form, Input, InputNumber, message,Modal} from 'antd';
function SonTypeAdd(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [info,setInfo] = useState({
        eowgts_content:'',
    });
    const [submitAdd] = useGwGoodsTypeSubAddMutation()
    return (
        <>
            <Button type='primary' onClick={() => {setOpen(true)}}>新增</Button>
            <Modal
                open={open}
                title='新增子类型'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    submitAdd({
                        eowgts_name:info.eowgts_name,
                        eowgts_e_id:localStorage.getItem('e_id'),
                        eowgts_uid:localStorage.getItem('eu_id'),
                        eowgts_uname:localStorage.getItem('eu_name'),
                        eowgts_eowgt_id:props.eowgt_id,
                        eowgts_serial_number:info.eowgts_serial_number,
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('新增成功！')  
                            setOpen(false);
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 6 }}                    
                >   
                    <Form.Item name="name" label='子类型名称' wrapperCol={{span:18}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,eowgts_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="serial" label='序号' wrapperCol={{span:18}} required>
                        <InputNumber  onChange={(e) => {setInfo(prevState=>({...prevState,eowgts_serial_number:e}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default SonTypeAdd